import React, { useEffect, useState } from "react";
import Actions from "../../../Actions";
import logger from "../../../utils/LoggerFrontend";
import { TextInput } from "../../../Components/Form";
import { useTranslation } from "react-i18next";
import { Group } from "../../../Components/Layout";
import {
  AddButton,
  AddButtonWrapper,
  CircleIconButton,
  Divider,
  EmailCard,
  EmailContainer,
  EmailFields,
  EmailInputWrapper,
  RightControls,
  SaveButton,
  Spacer,
  Wrapper
} from "./RexxIntegraiton.styles";
import { AddIcon, MinusIcon } from "../../../Components/Icons";

const maxLen = 200;
const ORGANIZATION_ID_MULTI_EMAIL = ["GvCen2rJ5wKq2uGZFviK", "-Kr5CZlS7jHaD5WfLalL"];

export const RexxIntegration = ({ organization, campaignData, campaignId, onSaveIntegration }) => {
  const { t } = useTranslation();
  const { id, name, integrations = {} } = organization;
  const { rexx = {} } = integrations;
  const isMultiEmail = ORGANIZATION_ID_MULTI_EMAIL.includes(id);

  const [emails, setEmails] = useState(
    campaignData?.integrations?.rexx?.emails || [{ email: "", name: "" }]
  );
  const [email, setEmail] = useState(
    !isMultiEmail ? campaignData?.integrations?.rexx?.email : undefined
  );

  logger.log("RexxIntegration", "called", {
    rexx,
    name,
    campaignData
  });

  useEffect(() => {
    const unsubscribeUpdateCampaign = Actions.updateCampaignWithId.completed.listen(() => {
      Actions.addNotification("Synchronisierung erfolgreich");
    });

    const unsubscribeUpdateCampaignFailed = Actions.updateCampaignWithId.failed.listen((error) => {
      logger.log("error:RexxIntegration", "unable to connect with rexx job", {
        error
      });

      Actions.addNotification("Synchronisierung nicht erfolgreich", "error");
    });

    return () => {
      unsubscribeUpdateCampaign();
      unsubscribeUpdateCampaignFailed();
    };
  }, [rexx]);

  const changeEmail = (e) => {
    setEmail(e.target.value);
  };

  const saveEmail = () => {
    const update = {
      integrations: { rexx: { ...rexx, email } }
    };
    Actions.updateCampaignWithId(campaignId, update);
    onSaveIntegration && onSaveIntegration(update);
  };

  const handleChange = (idx, field, value) => {
    setEmails((emails) =>
      emails.map((item, i) => (i === idx ? { ...item, [field]: value } : item))
    );
  };

  const handleAdd = () => {
    setEmails((emails) => [...emails, { email: "", name: "" }]);
  };

  const handleRemove = (idx) => {
    setEmails((emails) => emails.filter((_, i) => i !== idx));
  };

  const handleSaveEmails = () => {
    const update = {
      integrations: { rexx: { ...rexx, emails } }
    };
    Actions.updateCampaignWithId(campaignId, update);
    onSaveIntegration && onSaveIntegration(update);
  };

  const emailInvalid = (e) => !e || !e.includes("@") || !e.includes(".") || e.length > maxLen;
  const nameInvalid = (e) => e.length > maxLen;

  const invalid = isMultiEmail ? emails.some((e) => emailInvalid(e.email)) : emailInvalid(email);

  const noChange = isMultiEmail
    ? JSON.stringify(emails) === JSON.stringify(campaignData?.integrations?.rexx?.emails || [""])
    : email === campaignData?.integrations?.rexx?.email;

  return (
    <Wrapper>
      <h3>{name} - Rexx</h3>
      <Group width="100%" gap="1rem" align="flex-end" margin="2rem 0 0 0">
        {isMultiEmail ? (
          <EmailContainer>
            {emails.map((item, idx) => (
              <div key={idx}>
                {idx > 0 && <Divider />}
                <EmailCard>
                  <EmailFields>
                    <EmailInputWrapper>
                      <TextInput
                        value={item.email}
                        onChange={(ev) => handleChange(idx, "email", ev.target.value)}
                        invalid={emailInvalid(item.email)}
                        style={{ flex: 1, minHeight: 36 }}
                        placeholder="Email address"
                      />
                      <Spacer />
                      <TextInput
                        value={item.name}
                        onChange={(ev) => handleChange(idx, "name", ev.target.value)}
                        invalid={nameInvalid(item.name)}
                        style={{ marginTop: "0.5rem" }}
                        placeholder="Email name"
                      />
                    </EmailInputWrapper>
                    <RightControls>
                      <CircleIconButton
                        onClick={() => handleRemove(idx)}
                        type="button"
                        aria-label="Remove email"
                      >
                        <MinusIcon size="16" />
                      </CircleIconButton>
                    </RightControls>
                  </EmailFields>
                </EmailCard>
              </div>
            ))}
            <AddButtonWrapper>
              <AddButton onClick={handleAdd} type="button" aria-label="Add email">
                <AddIcon size="16" />
              </AddButton>
            </AddButtonWrapper>
            <SaveButton
              text={t("Save")}
              onClick={handleSaveEmails}
              disabled={invalid || noChange}
            />
          </EmailContainer>
        ) : (
          <>
            <TextInput label="Email" value={email} onChange={changeEmail} invalid={invalid} />
            <SaveButton text={t("Save")} onClick={saveEmail} disabled={invalid || noChange} />
          </>
        )}
      </Group>
    </Wrapper>
  );
};
